<template lang='pug' src='./OnHolidaysPopup.pug'></template>

<script>
  export default {
    name: 'OnHolidaysPopup',
    data: function () {
      return {
        date1: '01/05/2017',
        kaleidersList: [
          {
            'picture': 'https://plus.google.com/u/1/_/focus/photos/public/' +
              'AIbEiAIAAABECIuzu8Wc-u-jtgEiC3ZjYXJkX3Bob3RvKig3MzhkNTU3OGY' +
              '4OTcyZGVhNzg5MzRiZTVlNGZkMzI5NjcyY2VkZjhjMAEGq2OE5d_GfC5SSQ' +
              'eGYwIx29zrFg?sz=24',
            'name': 'Andres Gonzalez'
          },
          {
            'picture': 'https://plus.google.com/u/1/_/focus/photos/public/' +
              'AIbEiAIAAABDCIfSu6TTlY7rSiILdmNhcmRfcGhvdG8qKDMyMjJkZjYyYTU' +
              'zMGRjOGUwYmExNzQwOTIyMjBiNjU1MGZlZjNlOTkwAVSMcokS8uWp0XdN8E' +
              'k3q9mkq2ki?sz=24',
            'name': 'Pablo Alba'
          },
          {
            'picture': 'https://plus.google.com/u/1/_/focus/photos/private/' +
              'AIbEiAIAAABECMze_bqEtPjtxwEiC3ZjYXJkX3Bob3RvKig4NjZiNjk4MjJ' +
              'mZTA1ZWNhZWE1YzJhNDIzNWI5NDNhOGExNTI5YTRkMAHXJiJoMKGdYm3opj' +
              'lH-D5cza-78g?sz=24',
            'name': 'María Cano'
          },
          {
            'picture': 'https://plus.google.com/u/1/_/focus/photos/public/' +
              'AIbEiAIAAABDCJ-yne2G08HtcSILdmNhcmRfcGhvdG8qKDNlYzE1NTQzZmE' +
              'xNjhiOTFmYWRhZWFlY2FjYWNhNjIyMDg4MGNlYzEwAaCYL3WRCGFv-LCY5b' +
              'YResDi7f8N?sz=24',
            'name': 'Yamila Moreno'
          }
        ]
      }
    }
  }
</script>

<style lang='css' src='./OnHolidaysPopup.css' scoped></style>



// WEBPACK FOOTER //
// OnHolidaysPopup.vue?c2dfa0a8